import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { SelectDropdownComponent } from './components/select-dropdown/select-dropdown.component';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loader/loader.component';
import { ToastMessageComponent } from './components/toast-message/toast-message.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { SiteSequencerTableComponent } from './components/site-sequencer-table/site-sequencer-table.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { SequenceValidationPopupComponent } from './components/sequence-validation-popup/sequence-validation-popup.component';
import { EditAndDeleteConfirmationModalComponent } from './components/edit-and-delete-confirmation-modal/edit-and-delete-confirmation-modal.component';
import { SequenceScopeSelectionModalComponent } from './components/sequence-scope-selection-modal/sequence-scope-selection-modal.component';
import { ErrorTypeLegendsComponent } from './components/error-type-legends/error-type-legends.component';
import { tooltipDirective } from './directives/tooltip.directive';
import { DeliveryLogsTableComponent } from './components/delivery-logs-table/delivery-logs-table.component';
import { CcuLogsModalComponent } from './components/ccu-logs-modal/ccu-logs-modal.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ModalListDialogComponent } from './components/modal-list-dialog/modal-list-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PushDevicePopupComponent } from './components/push-device-popup/push-device-popup.component';
import { CdkTableModule } from '@angular/cdk/table';
import { DeliveryDebugInfoModalComponent } from './components/delivery-debug-info-modal/delivery-debug-info-modal.component';
import { CommonSearchComponent } from './components/common-search/common-search.component';
import { QuickFiltersComponent } from './components/quick-filters/quick-filters.component';
import { SubscriptionReminderPopupComponent } from './components/subscription-reminder-popup/subscription-reminder-popup.component';
import { AccesRestrictionPopupComponent } from './components/access-restriction-popup/access-restriction-popup.component';
import { CommonTooltipDirective } from './directives/common-tooltip.directive';
import { AddPointModelComponent } from './components/add-point-model/add-point-model.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EquipmentBuilderDialogComponent } from './components/equipment-builder-dialog/equipment-builder-dialog.component';
// Declare the PDF preview alongside the equipment-builder dialog so it can be opened through MatDialog.
import { EquipmentBuilderCddPreviewComponent } from './components/equipment-builder-cdd-preview/equipment-builder-cdd-preview.component';
import { EquipmentBuilderBlocklyPreviewComponent } from './components/equipment-builder-blockly-preview/equipment-builder-blockly-preview.component';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
@NgModule({
  declarations: [
    SelectDropdownComponent,
    LoaderComponent,
    ToastMessageComponent,
    ConfirmModalComponent,
    SiteSequencerTableComponent,
    AccordionComponent,
    SequenceValidationPopupComponent,
    EditAndDeleteConfirmationModalComponent,
    SequenceScopeSelectionModalComponent,
    PushDevicePopupComponent,
    ModalListDialogComponent,
    ErrorTypeLegendsComponent,
    DeliveryLogsTableComponent,
    CcuLogsModalComponent,
    DeliveryDebugInfoModalComponent,
    CommonSearchComponent,
    QuickFiltersComponent,
    SubscriptionReminderPopupComponent,
    AccesRestrictionPopupComponent,
    CommonTooltipDirective,
    AddPointModelComponent,
    EquipmentBuilderDialogComponent,
    EquipmentBuilderCddPreviewComponent,
    EquipmentBuilderBlocklyPreviewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    MaterialModule,
    CdkTableModule,
    NgxJsonViewerModule,
    CodemirrorModule,
    NgSelectModule,
    NgxSkeletonLoaderModule.forRoot({ animation: 'pulse', loadingText: 'This item is actually loading...' }),
    tooltipDirective,
  ],
  exports: [
    MaterialModule,
    FormsModule,
    NgxJsonViewerModule,
    CodemirrorModule,
    SelectDropdownComponent,
    LoaderComponent,
    ToastMessageComponent,
    ConfirmModalComponent,
    AccordionComponent,
    SiteSequencerTableComponent,
    SequenceValidationPopupComponent,
    ErrorTypeLegendsComponent,
    tooltipDirective,
    DeliveryLogsTableComponent,
    NgxSkeletonLoaderModule,
    CommonSearchComponent,
    QuickFiltersComponent,
    AccesRestrictionPopupComponent,
    CommonTooltipDirective,
    AddPointModelComponent,
    EquipmentBuilderDialogComponent,
    EquipmentBuilderCddPreviewComponent,
    EquipmentBuilderBlocklyPreviewComponent
  ]
})
export class SharedModule { }
